import router from '../../router'
import apiCall from '../../plugins/api'

const state = {
  status: '',
  days: [],
  day: {}
}

const getters = {
  commondaysStatus: state => state.status,
  commondays: state => state.days,
  commonday: state => state.day
}

const actions = {
  ['COMMONDAYS_GET']: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: '/api/common-days', data: {} , method: 'GET' })
        .then(resp => {
          if (resp.status === 'success') {
            commit('COMMONDAYS_SUCCESS', resp)
            resolve(resp)
          } else if (resp.status === 'authError') {
            commit('AUTH_ERROR')
            dispatch('AUTH_LOGOUT')
              .then(() => {
                router.push('/login/')
              })
            reject()
          } else {
            commit('COMMONDAYS_ERROR')
            resolve(resp)
          }
        })
        .catch(err => {
          commit('COMMONDAYS_ERROR')
          resolve(err)
        })
    })
  },
  ['COMMONDAYS_UPDATE']: ({ commit, dispatch }, day) => {
    return new Promise((resolve, reject) => {
      commit('COMMONDAYS_UPDATE')
      apiCall({ url: '/api/common-days/edit', data: day, method: 'POST' })
        .then(resp => {
          if (resp.status === 'success') {
            commit('COMMONDAYS_UPDATE_SUCCESS')
            resolve(resp)
          } else if (resp.status === 'authError') {
            commit('AUTH_ERROR')
            dispatch('AUTH_LOGOUT')
              .then(() => {
                router.push('/login/')
              })
            reject()
          } else {
            commit('COMMONDAYS_ERROR')
            resolve(resp)
          }
        })
        .catch(err => {
          commit('COMMONDAYS_ERROR', err)
          reject(err)
        })
    })
  },
  ['COMMONDAYS_GET_DAY']: ({ commit, dispatch }, day) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: '/api/common-days/' + day.id, data: {} , method: 'GET' })
        .then(resp => {
          if (resp.status === 'success') {
            commit('COMMONDAYS_SUCCESS', resp)
            resolve(resp)
          } else if (resp.status === 'authError') {
            commit('AUTH_ERROR')
            dispatch('AUTH_LOGOUT')
              .then(() => {
                router.push('/login/')
              })
            reject()
          } else {
            commit('COMMONDAYS_ERROR')
            resolve(resp)
          }
        })
        .catch(err => {
          commit('COMMONDAYS_ERROR')
          resolve(err)
        })
    })
  },
  ['COMMONDAYS_SET']: ({ commit }, day) => {
    return new Promise((resolve) => {
      commit('COMMONDAYS_SET', day)
      resolve()
    })
  }
}

const mutations = {
  ['COMMONDAYS_UPDATE']: (state) => {
    state.status = 'updating'
  },
  ['COMMONDAYS_UPDATE_SUCCESS']: (state) => {
    state.status = 'success'
  },
  ['COMMONDAYS_SUCCESS']: (state, resp) => {
    state.status = 'success'
    state.days = resp.days || []
    state.day = resp.day || {}

  },
  ['COMMONDAYS_ERROR']: (state) => {
    state.status = 'error'
  },
  ['COMMONDAYS_SET']: (state, day) => {
    state.day = day
  },
  ['COMMONDAYS_CLEAN']: (state) => {
    state.days = []
    state.day = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
